import React from "react";
import { formatDateVN } from "../../../utils/formatUtils";
import { Building2, Clock, MapPin } from "lucide-react";

const AttendanceLogTable = ({
    data,
    currentPage,
    pageSize,
    onSelectLog,
  }) => {

  // ❗️KHÔNG SỬ DỤNG SLICE FE NỮA
  const currentData = data; // <-- BE đã phân trang
  
  const formatWorkDuration = (duration) => {
    if (!duration) return "-";
  
    // CASE: PostgreSQL interval object {hours, minutes, seconds}
    if (typeof duration === "object") {
      const h = duration.hours ?? 0;
      const m = duration.minutes ?? 0;
      return `${h}h ${m}m`;
    }
  
    // CASE: string HH:MM:SS → fallback
    if (typeof duration === "string" && duration.includes(":")) {
      const [h, m] = duration.split(":").map((n) => parseInt(n, 10));
      return `${h}h ${m}m`;
    }
  
    // CASE: number total minutes
    if (typeof duration === "number") {
      const h = Math.floor(duration / 60);
      const m = duration % 60;
      return `${h}h ${m}m`;
    }
  
    return "-";
  };
  return (
<div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
  <div className="overflow-x-auto">
    <table className="w-full table-auto border-collapse">
      <thead>
        <tr className="bg-gray-50/50 border-b border-gray-100 text-left">
          <th className="p-4 w-[50px] text-center text-xs font-bold text-gray-400 uppercase tracking-wider">#</th>
          <th className="p-4 min-w-[220px] text-xs font-bold text-gray-400 uppercase tracking-wider">Nhân viên & Bộ phận</th>
          <th className="p-4 min-w-[150px] text-xs font-bold text-gray-400 uppercase tracking-wider">Chi nhánh</th>
          <th className="p-4 min-w-[140px] text-center text-xs font-bold text-gray-400 uppercase tracking-wider">Ngày làm việc</th>
          <th className="p-4 min-w-[180px] text-center text-xs font-bold text-gray-400 uppercase tracking-wider">Giờ Vào/Ra</th>
          <th className="p-4 min-w-[100px] text-center text-xs font-bold text-gray-400 uppercase tracking-wider">Tổng giờ</th>
          <th className="p-4 min-w-[130px] text-center text-xs font-bold text-gray-400 uppercase tracking-wider">Định vị</th>
          <th className="p-4 min-w-[140px] text-center text-xs font-bold text-gray-400 uppercase tracking-wider">Trạng thái</th>
          <th className="p-4 w-[60px] text-center"></th>
        </tr>
      </thead>

      <tbody className="divide-y divide-gray-50">
        {currentData.length === 0 ? (
          <tr>
            <td colSpan={8} className="p-20 text-center">
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-gray-50 rounded-2xl flex items-center justify-center mb-4 text-gray-200 text-3xl">📁</div>
                <p className="text-gray-400 font-medium text-sm">Không có dữ liệu chấm công.</p>
              </div>
            </td>
          </tr>
        ) : (
          currentData.map((item, index) => {
            // Giữ nguyên logic xử lý status và location của bạn
            let statusLabel = "Không xác định";
            let statusColor = "bg-gray-100 text-gray-600 border-gray-200";
            if (item.status === "completed" || item.status === "checkout") {
              statusLabel = "Hoàn thành";
              statusColor = "bg-green-50 text-green-700 border-green-100";
            } else if (item.status === "missing_checkout") {
              statusLabel = "Thiếu checkout";
              statusColor = "bg-red-50 text-red-700 border-red-100";
            } else if (item.status === "checkin") {
              statusLabel = "Đang làm việc";
              statusColor = "bg-orange-50 text-orange-700 border-orange-100";
            }

            const inLoc = (item.check_in_location || "").trim();
            const outLoc = (item.check_out_location || "").trim();
            const isValidIn = inLoc && inLoc !== "Không xác định" && inLoc.includes(",");
            const isValidOut = outLoc && outLoc !== "Không xác định" && outLoc.includes(",");

            let locLabel = "Không định vị";
            let locColor = "bg-red-50 text-red-600 border-red-100";
            if (isValidIn && isValidOut) {
              locLabel = "Đủ định vị";
              locColor = "bg-blue-50 text-blue-600 border-blue-100";
            } else if (isValidIn || isValidOut) {
              locLabel = "Thiếu định vị";
              locColor = "bg-yellow-50 text-yellow-600 border-yellow-100";
            }

            return (
              <tr
                key={item.id}
                role="button"
                tabIndex={0}
                onClick={() => onSelectLog?.(item)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onSelectLog?.(item);
                  }
                }}
                className="hover:bg-red-50/30 transition-colors group cursor-pointer"
              >
                {/* 1. STT */}
                <td className="p-4 text-sm text-gray-400 text-center font-medium italic">
                  {(currentPage - 1) * pageSize + index + 1}
                </td>

                {/* 2. NHÂN VIÊN */}
                <td className="p-4">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-red-100 text-red-600 flex items-center justify-center font-bold text-sm shrink-0 border border-white">
                      {item.employee_name?.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 group-hover:text-red-600 transition-colors text-sm capitalize">
                        {item.employee_name?.toLowerCase()}
                      </div>
                      <div className="text-[10px] text-gray-500 font-medium italic">
                        {item.department_name || "Chưa có bộ phận"}
                      </div>
                    </div>
                  </div>
                </td>

                {/* 3. CHI NHÁNH */}
                <td className="p-4">
                  <div className="flex items-center gap-1.5 text-xs font-bold text-gray-700">
                    <Building2 size={14} className="text-gray-400" />
                    {item.branch_name}
                  </div>
                </td>

                {/* 4. NGÀY LÀM VIỆC */}
                <td className="p-4 text-center">
                  <div className="inline-block px-2 py-1 bg-gray-50 rounded text-xs font-bold text-gray-600 border border-gray-100 uppercase tracking-tighter">
                    {formatDateVN(item.work_date)}
                  </div>
                </td>

                {/* 5. GIỜ VÀO - RA */}
                <td className="p-4">
                  <div className="flex items-center justify-center gap-2">
                    <div className="text-center">
                      <div className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">Vào</div>
                      <div className="text-sm font-bold text-gray-700">{item.check_in_time?.slice(0,5) || "--:--"}</div>
                    </div>
                    <div className="h-4 w-[1px] bg-gray-200 mx-1"></div>
                    <div className="text-center">
                      <div className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">Ra</div>
                      <div className="text-sm font-bold text-gray-700">{item.check_out_time?.slice(0,5) || "--:--"}</div>
                    </div>
                  </div>
                </td>

                {/* 6. THỜI GIAN */}
                <td className="p-4 text-center">
                  <div className="flex items-center justify-center gap-1 text-xs font-bold text-red-600 bg-red-50/50 py-1 rounded-lg border border-red-100">
                    <Clock size={12} />
                    {formatWorkDuration(item.work_duration)}
                  </div>
                </td>

                {/* 7. ĐỊNH VỊ (MAPS) */}
                <td className="p-4 text-center">
                   <div className="flex flex-col items-center gap-1">
                      <span className={`text-[10px] px-2 py-0.5 rounded-full font-bold uppercase border ${locColor}`}>
                        {locLabel}
                      </span>
                      <div className="flex gap-2">
                        {isValidIn && (
                          <a
                            href={`https://www.google.com/maps?q=${item.check_in_location}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="p-1 text-blue-500 hover:bg-blue-50 rounded transition-colors"
                            title="Bản đồ vào"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <MapPin size={14} />
                          </a>
                        )}
                        {isValidOut && (
                          <a
                            href={`https://www.google.com/maps?q=${item.check_out_location}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="p-1 text-orange-500 hover:bg-orange-50 rounded transition-colors"
                            title="Bản đồ ra"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <MapPin size={14} />
                          </a>
                        )}
                      </div>
                   </div>
                </td>

                {/* 8. TRẠNG THÁI */}
                <td className="p-4 text-center">
                  <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wide border ${statusColor}`}>
                    <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${item.status === "checkin" ? "bg-orange-500 animate-pulse" : "bg-current opacity-60"}`} />
                    {statusLabel}
                  </span>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  </div>
</div>






  );
};

export default AttendanceLogTable;
